module.exports = __webpack_public_path__ + "assets/img/car22.dc3f1ef9.jpg";